// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfirmDrawProjectStageQueryVariables = Types.Exact<{
  projectStageId: Types.Scalars['ID']['input'];
}>;


export type ConfirmDrawProjectStageQuery = { __typename?: 'Query', projectStage: { __typename?: 'ProjectStage', id: string, allContractDraws: Array<{ __typename?: 'HomeownerContractDraw', id: string, name: string, amountInCents: number, percent: number, parent:
        | { __typename?: 'HomeownerContract', id: string }
        | { __typename?: 'HomeownerContractChangeOrder', id: string }
      , task: { __typename?: 'Task', id: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus }, interval: { __typename?: 'CalendarInterval', endDate: Types.Scalars['Date']['input'] } }, invoiceDrawLineItem?: { __typename?: 'InvoiceDrawLineItem', id: string, invoice: { __typename?: 'Invoice', id: string } } | null | undefined }> } };

export type HomeownerContractDrawItemFragment = { __typename?: 'HomeownerContractDraw', id: string, name: string, amountInCents: number, percent: number, parent:
    | { __typename?: 'HomeownerContract', id: string }
    | { __typename?: 'HomeownerContractChangeOrder', id: string }
  , task: { __typename?: 'Task', id: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus }, interval: { __typename?: 'CalendarInterval', endDate: Types.Scalars['Date']['input'] } }, invoiceDrawLineItem?: { __typename?: 'InvoiceDrawLineItem', id: string, invoice: { __typename?: 'Invoice', id: string } } | null | undefined };

export const HomeownerContractDrawItemFragmentDoc = gql`
    fragment HomeownerContractDrawItem on HomeownerContractDraw {
  id
  name
  amountInCents
  percent
  parent {
    id
  }
  task {
    id
    status {
      code
    }
    interval {
      endDate
    }
  }
  invoiceDrawLineItem {
    id
    invoice {
      id
    }
  }
}
    `;
export const ConfirmDrawProjectStageDocument = gql`
    query ConfirmDrawProjectStage($projectStageId: ID!) {
  projectStage(id: $projectStageId) {
    id
    allContractDraws {
      ...HomeownerContractDrawItem
    }
  }
}
    ${HomeownerContractDrawItemFragmentDoc}`;

/**
 * __useConfirmDrawProjectStageQuery__
 *
 * To run a query within a React component, call `useConfirmDrawProjectStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmDrawProjectStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmDrawProjectStageQuery({
 *   variables: {
 *      projectStageId: // value for 'projectStageId'
 *   },
 * });
 */
export function useConfirmDrawProjectStageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables> & ({ variables: ConfirmDrawProjectStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>(ConfirmDrawProjectStageDocument, options);
      }
export function useConfirmDrawProjectStageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>(ConfirmDrawProjectStageDocument, options);
        }
// @ts-ignore
export function useConfirmDrawProjectStageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>;
export function useConfirmDrawProjectStageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmDrawProjectStageQuery | undefined, ConfirmDrawProjectStageQueryVariables>;
export function useConfirmDrawProjectStageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>(ConfirmDrawProjectStageDocument, options);
        }
export type ConfirmDrawProjectStageQueryHookResult = ReturnType<typeof useConfirmDrawProjectStageQuery>;
export type ConfirmDrawProjectStageLazyQueryHookResult = ReturnType<typeof useConfirmDrawProjectStageLazyQuery>;
export type ConfirmDrawProjectStageSuspenseQueryHookResult = ReturnType<typeof useConfirmDrawProjectStageSuspenseQuery>;
export type ConfirmDrawProjectStageQueryResult = ApolloReactCommon.QueryResult<ConfirmDrawProjectStageQuery, ConfirmDrawProjectStageQueryVariables>;